var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9746,
    cy: 18,
    r: 18,
    fill: "#416AF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0236 8.92705C18.3229 8.00574 19.6263 8.00574 19.9257 8.92705L21.4443 13.6008C21.5781 14.0128 21.9621 14.2918 22.3953 14.2918H27.3096C28.2783 14.2918 28.6811 15.5314 27.8974 16.1008L23.9216 18.9894C23.5712 19.244 23.4245 19.6954 23.5584 20.1074L25.077 24.7812C25.3763 25.7025 24.3218 26.4686 23.5381 25.8992L19.5624 23.0106C19.2119 22.756 18.7373 22.756 18.3868 23.0106L14.4111 25.8992C13.6274 26.4686 12.5729 25.7025 12.8722 24.7812L14.3908 20.1074C14.5247 19.6954 14.3781 19.244 14.0276 18.9894L10.0518 16.1008C9.26812 15.5314 9.67089 14.2918 10.6396 14.2918H15.5539C15.9871 14.2918 16.3711 14.0128 16.505 13.6008L18.0236 8.92705Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.29b4edce26032298b84413d9aed500d6.svg";
export { ForwardRef as ReactComponent };